/*@ngInject*/
const DeclineMediator = function (declineSubmissionRepository) {

    this.createDeclinationForm = function (submissionId) {
        return declineSubmissionRepository.createDeclinationForm(submissionId);
    };

    this.deleteDeclinationForm = function (submissionId) {
        return declineSubmissionRepository.deleteDeclinationForm(submissionId);
    }
};

angular.module('gw-um-submission')
    .service('declineMediator', DeclineMediator);
